module.exports = __webpack_public_path__ + "img/profile_leonos@2x.34419b1c.png";